/** @format */

import React, { useState, useEffect } from "react";
import Table from "../../../Components/Table/Index";
import { useGetAll } from "../../../Hooks/useGetAll";
import { red, green } from "@mui/material/colors";
import PrimaryButton from "../../../Components/Inputs/PrimaryButton";
import AddCategory from "../../../Components/AdminPanelDialogs/AddCategory/Index";
import { Link } from "react-router-dom";
import { useQueryClient } from "react-query";

// Import icons from Material-UI
import ActiveIcon from "@mui/icons-material/CheckCircle";
import InactiveIcon from "@mui/icons-material/Cancel";

function Index() {
  const { data: CampaignCategory, refetch } = useGetAll({
    key: `campaign/categories/nt/`,
    select: (data) => data?.data?.row,
    onSuccess: (data) => {
      // console.log(data, "<----------data");
      setRows(mapApiDataToTableRows(data));
    },
  });

  const [rows, setRows] = useState([]);

  const handleEdit = (id) => {
    console.log("Edit campaign with ID:", id);
    // Add your edit functionality here
  };

  const mapApiDataToTableRows = (apiData) => {
    return apiData?.map((item) => ({
      id: item.category_id,
      category_id: item.category_id,
      category_title: item.category_title,
      is_active: item.is_active,
      createdAt: new Date(item.createdAt).toLocaleDateString(),
    }));
  };

  const columns = [
    // { field: "category_id", headerName: "ID", width: 70 },
    { field: "category_title", headerName: "Title", width: 130 },
    {
      field: "is_active",
      headerName: "Status",
      width: 130,
      renderCell: (params) => {
        const isActive = params.value;
        return (
          <span
            className='py-1 px-2 rounded-md flex items-center'
            style={{
              color: isActive ? green[500] : red[500],
            }}
          >
            {isActive ? (
              <ActiveIcon style={{ color: green[500], marginRight: "8px" }} />
            ) : (
              <InactiveIcon style={{ color: red[500], marginRight: "8px" }} />
            )}
            {isActive ? "Active" : "Inactive"}
          </span>
        );
      },
    },
    {
      field: "createdAt",
      headerName: "Date",
      type: "string",
      width: 130,
    },
    {
      field: "actions",
      headerName: "Actions",
      width: 150,
      sortable: false,
      renderCell: (params) => (
        <Link to='Edit' state={{ id: params?.id }}>
          {console.log(params, "<-----------------")}
          <PrimaryButton
            sx={{
              borderRadius: 1,
              height: "30px",
              background: "#115e59",
              "&:hover": {
                background: "#0e8073",
              },
            }}
            onClick={() => handleEdit(params.id)}
          >
            Edit
          </PrimaryButton>
        </Link>
      ),
    },
  ];
  useEffect(() => {
    if (CampaignCategory) {
      setRows(mapApiDataToTableRows(CampaignCategory));
    }
  }, [CampaignCategory]);
  return (
    <div className=''>
      <Table
        columns={columns}
        title="Category's"
        rows={rows}
        DeleteUrl={`/campaign/delete-multiple-categories/`}
        refetchUrl={`campaign/categories/nt/`}
        addButton={<AddCategory onSuccess={refetch} />}
      />
    </div>
  );
}

export default Index;
